import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { WEB_DEPLOYMENT_CONFIG } from "./deployment-config.js";
import { installKeyboardNavigationMode } from "./keyboard-navigation.js";
import { prepareW7Controller } from "./w7-controller.js";
import "./styles.css";

const root = document.querySelector<HTMLDivElement>("#root");
if (root === null) throw new Error("Missing #root mount point");
installKeyboardNavigationMode(document);
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

if (import.meta.env.PROD) {
  window.addEventListener("load", () => {
    void prepareW7Controller(WEB_DEPLOYMENT_CONFIG.shareOrigin)
      .then((controller) => {
        if (!controller.enabled) return;
        // Deploy the reader/verifier behind the exact controller floor, but do
        // not create a caller or let its load/failure affect legacy admission.
        void import("./w7-dormant-browser.js").catch(() => undefined);
      })
      .catch(() => undefined);
  });
}
